@use "ui/styles/effects";
@use "ui/styles/fonts";
@use "ui/styles/sizes";

.modal {
  --table-controls-background-color: transparent;
}

.wrapper {
  display: flex;
  flex-direction: column;
  gap: sizes.$s6;
}

.summaryStrip {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: sizes.$s3;
}

.summaryCard {
  border: 1px solid var(--border-color);
  border-radius: effects.$borderRadiusM;
  background: linear-gradient(140deg, var(--secondary-background-color), var(--background-color));
  padding: sizes.$s4;
}

.summaryLabel {
  color: var(--secondary-text-color);
  font-size: fonts.$small;
}

.summaryValue {
  margin-top: sizes.$s1;
  color: var(--text-color);
  font-size: fonts.$large;
  font-weight: fonts.$bold;
}

.viewSelector {
  display: flex;
  flex-wrap: wrap;
  gap: sizes.$s2;
}

.section {
  border: 1px solid var(--border-color);
  border-radius: effects.$borderRadiusM;
  background: var(--background-color);
  padding: sizes.$s4;
}

.sectionHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: sizes.$s2;
  margin-bottom: sizes.$s2;
}

.sectionTitle {
  margin: 0;
  color: var(--text-color);
  font-size: fonts.$mid;
  font-weight: fonts.$bold;
}

.metaText {
  margin: 0 0 sizes.$s3;
  color: var(--secondary-text-color);
  font-size: fonts.$small;
}

.keyValueGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: sizes.$s2;
}

.keyValueRow {
  display: flex;
  flex-direction: column;
  gap: sizes.$s1;
  border: 1px solid var(--border-color);
  border-radius: effects.$borderRadiusS;
  background: var(--secondary-background-color);
  padding: sizes.$s3;
}

.key {
  color: var(--secondary-text-color);
  font-size: fonts.$small;
}

.value {
  color: var(--text-color);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: fonts.$small;
}

.inlineSwitch {
  white-space: nowrap;
}

.badgeList {
  display: flex;
  flex-wrap: wrap;
  gap: sizes.$s2;
  margin-bottom: sizes.$s3;
}

.badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: sizes.$s1 sizes.$s3;
  border: 1px solid var(--border-color);
  background: var(--secondary-background-color);
  color: var(--text-color);
  font-size: fonts.$small;
  font-weight: fonts.$bold;
}

.roleMetaRow {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: sizes.$s2;
  margin-bottom: sizes.$s3;
}

.roleMetaBlock {
  display: flex;
  flex-direction: column;
  gap: sizes.$s1;
  border: 1px solid var(--border-color);
  border-radius: effects.$borderRadiusS;
  background: var(--secondary-background-color);
  padding: sizes.$s3;
}

.roleMetaLabel {
  color: var(--secondary-text-color);
  font-size: fonts.$small;
}

.roleMetaValue {
  color: var(--text-color);
  font-size: fonts.$mid;
  font-weight: fonts.$bold;
}

.roleImpersonationActive {
  border-color: #e5c658;
  background: #fff6d8;
}

.debugButton {
  min-width: 64px;
}

.featureFlagsInfoMessage {
  margin: sizes.$s1 0 sizes.$s2;
}

.reasonPopover {
  max-width: 560px;
}

.reasonTooltip {
  margin: 0;
  min-width: 320px;
  max-width: 520px;
  max-height: 320px;
  overflow: auto;
}

.emptyState {
  margin: 0 0 sizes.$s3;
  color: var(--secondary-text-color);
  font-size: fonts.$small;
}

@media (max-width: 800px) {
  .sectionHeader {
    flex-direction: column;
    align-items: flex-start;
  }

  .roleMetaRow {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .reasonTooltip {
    min-width: 220px;
    max-width: 300px;
  }
}
